import React from "react";
import type { Step, HubSpotProduct } from "../../types/configurator";
import { EyeIcon } from "../ui/Icons";
import { CustomerPreview } from "./CustomerPreview";
import "./PreviewPanel.css";

interface Props {
  steps: Step[];
  productMap: Record<string, HubSpotProduct>;
}

export const PreviewPanel: React.FC<Props> = ({ steps, productMap }) => {
  return (
    <aside className="preview">
      <div className="preview-header">
        <h2>
          <EyeIcon /> Preview
        </h2>
      </div>

      <div className="preview-content">
        <CustomerPreview steps={steps} productMap={productMap} />
      </div>
    </aside>
  );
};
